import { forwardRef } from 'react';

const WhyItMatters = forwardRef<HTMLElement>((props, ref) => {
  return (
    <section
      ref={ref}
      className="relative w-full overflow-hidden opacity-0 transition-all duration-[800ms]"
      id="why-it-matters"
      style={{ minHeight: '90vh' }}
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/2cfa864ebc41e48c65926819894d1237.jpg)',
          filter: 'saturate(0.65)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" />

      {/* Content */}
      <div className="relative z-10 flex items-center py-24 md:py-32" style={{ minHeight: '90vh' }}>
        <div className="w-full px-6 md:px-0 md:ml-[120px] md:max-w-[680px] text-center md:text-left pb-16 md:pb-24">

          <p className="text-[#C9A96E] font-sans uppercase mb-6 md:mb-[48px]" style={{ fontSize: '10px', letterSpacing: '0.45em' }}>
            The Transformation
          </p>

          <h2
            className="font-serif text-white leading-[0.95] tracking-[-0.015em] mb-8 md:mb-[48px]"
            style={{
              fontSize: 'clamp(40px, 6vw, 88px)',
              fontFamily: '"Playfair Display", Georgia, serif',
            }}
          >
            The Main Room<br />
            <em style={{ fontStyle: 'italic', color: 'rgba(255,255,255,0.75)' }}>Awaits.</em>
          </h2>

          <p
            className="text-white/75 font-sans leading-[1.85] tracking-[0.015em] mb-4 md:mb-[24px] mx-auto md:mx-0"
            style={{ fontSize: 'clamp(15px, 2vw, 18px)', maxWidth: '520px' }}
          >
            Every summit. Every bilateral. Every press conference. Every moment where a nation's reputation is made or diminished — these are the rooms that define legacies.
          </p>
          <p
            className="text-white/75 font-sans leading-[1.85] tracking-[0.015em] mb-10 md:mb-[72px] mx-auto md:mx-0"
            style={{ fontSize: 'clamp(15px, 2vw, 18px)', maxWidth: '520px' }}
          >
            Anteroom exists so that when you step through that door, you are not hoping to perform. You are ready to lead.
          </p>

          <div className="flex flex-col md:flex-row items-center md:items-center gap-6 md:gap-[40px]">
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-5 border border-[#C9A96E] text-[#C9A96E] font-sans uppercase px-8 py-4 md:px-[52px] md:py-[20px] hover:bg-[#C9A96E] hover:text-[#0D0C0A] transition-all duration-500 whitespace-nowrap cursor-pointer w-full md:w-auto"
              style={{ fontSize: '9px', letterSpacing: '0.32em' }}
            >
              Begin Your Preparation
              <span className="w-[18px] h-[1px] bg-current inline-block" />
            </a>

            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-white/50 font-sans uppercase hover:text-white/80 transition-colors duration-300 whitespace-nowrap cursor-pointer text-center"
              style={{ fontSize: '9px', letterSpacing: '0.28em' }}
            >
              Our Mandate →
            </a>
          </div>

          {/* Stats row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-[60px] mt-12 md:mt-[80px] pt-8 md:pt-[60px] border-t border-white/15">
            {[
              { value: '12+', label: 'Governments Served' },
              { value: '200+', label: 'Senior Officials Coached' },
              { value: '4', label: 'Core Disciplines' },
              { value: '3', label: 'Strategic Offices' },
            ].map((s, i) => (
              <div key={i} className="text-center md:text-left">
                <p
                  className="text-white font-serif mb-[6px]"
                  style={{ fontSize: 'clamp(28px, 5vw, 36px)', fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '-0.01em' }}
                >
                  {s.value}
                </p>
                <p className="text-white/40 font-sans uppercase" style={{ fontSize: '9px', letterSpacing: '0.22em' }}>
                  {s.label}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
});

WhyItMatters.displayName = 'WhyItMatters';

export default WhyItMatters;
